export default __webpack_public_path__ + "static/media/clock-time.bb4bdc80.svg";